import { render, staticRenderFns } from "./ReportHuaningOweFeeDetail.vue?vue&type=template&id=6f7d1b10&scoped=true"
import script from "./ReportHuaningOweFeeDetail.vue?vue&type=script&lang=js"
export * from "./ReportHuaningOweFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportHuaningOweFeeDetail.vue?vue&type=style&index=0&id=6f7d1b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7d1b10",
  null
  
)

export default component.exports